import { IFatigueRow } from 'types/fatigue.interface'

export const MOCK_FATIGUE_ROWS: IFatigueRow[] = [
  {
    id: 1,
    level: 'critical',
    name: 'Marko Stankovic',
    role: 'Equipment Operator',
    siteId: 1,
    departmentId: 2,
    index: 0.92,
    hours7d: 68,
    consecutiveDays: 7,
    overrideActive: false,
  },
  {
    id: 2,
    level: 'high',
    name: 'Ana Petrovic',
    role: 'Shift Lead',
    siteId: 1,
    departmentId: 1,
    index: 0.81,
    hours7d: 62,
    consecutiveDays: 6,
    overrideActive: true,
  },
  {
    id: 3,
    level: 'high',
    name: 'Stefan Jovic',
    role: 'Drill Operator',
    siteId: 1,
    departmentId: 1,
    index: 0.74,
    hours7d: 55,
    consecutiveDays: 5,
    overrideActive: false,
  },
  {
    id: 4,
    level: 'elevated',
    name: 'Jelena Maric',
    role: 'Geologist',
    siteId: 2,
    departmentId: 4,
    index: 0.62,
    hours7d: 48,
    consecutiveDays: 5,
    overrideActive: false,
  },
  {
    id: 5,
    level: 'elevated',
    name: 'Nikola Ilic',
    role: 'Truck Operator',
    siteId: 1,
    departmentId: 2,
    index: 0.55,
    hours7d: 44,
    consecutiveDays: 4,
    overrideActive: false,
  },
  {
    id: 6,
    level: 'low',
    name: 'Milica Pavlovic',
    role: 'Maintenance Tech',
    siteId: 2,
    departmentId: 3,
    index: 0.42,
    hours7d: 38,
    consecutiveDays: 3,
    overrideActive: false,
  },
  {
    id: 7,
    level: 'low',
    name: 'Vuk Tomic',
    role: 'Safety Officer',
    siteId: 1,
    departmentId: 1,
    index: 0.28,
    hours7d: 24,
    consecutiveDays: 2,
    overrideActive: false,
  },
]
